<template>
  <div class="locale-changer">
    <label for="lang-select">{{ $t('SELECT_LANGUAGE') }}</label>
    <select id="lang-select" v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
    </select>
  </div>
</template>

<script>
  export default {
    name: 'locale-changer',
    data () {
      return { langs: ['en', 'ja'] }
    }
  }
</script>
